import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useActions, useFetching } from '@mssgme/hooks';
import { getConversation } from '@mssgme/store';

export default function useMessagesFooter(contactId) {
    const { api } = useActions();
    const isAssigned = useSelector((state) => !!getConversation(state, contactId).assignTo);

    const onSendMessage = useCallback(
        ({ message }) =>
            message &&
            api.conversations.sendMessage({
                contactId,
                payload: { text: message },
            }),
        [contactId, api]
    );
    const { run: onSendAttachment, pending: isFetching } = useFetching(
        ({ attachment }) =>
            attachment && api.conversations.sendAttachment({ contactId, payload: { file: attachment } }),
        [contactId, api]
    );
    const onAssign = useCallback(() => api.conversations.assignMe({ contactId }), [contactId, api]);

    return {
        isAssigned,
        isFetching,
        onSendMessage,
        onSendAttachment,
        onAssign,
    };
}
